import { render, staticRenderFns } from "./ProductHierarchy.vue?vue&type=template&id=31079258"
import script from "./ProductHierarchy.vue?vue&type=script&lang=js"
export * from "./ProductHierarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports